<template>
    <div class='hotsite-wrapper'>
        <div class='d-flex flex-justify-center'>
            <a href='/promo' target='_blank'>
                <picture>
                    <source
                        :srcset='`${$scope.CDN_IMAGES}/images/hotsites/blackfriday-2024/banner_home_mob_BF_dia01_041124.png?auto=compress,format&q=65`'
                        media='(max-width: 576px)'
                    />
                    <img
                        :src='`${$scope.CDN_IMAGES}/images/hotsites/blackfriday-2024/banner_home_desktop_BF_dia01_041124.png?auto=compress,format&q=65`'
                        class='item-img img-responsive'
                    />
                </picture>
            </a>
        </div>
            <div id='content-basicas'>
            <div class='section-basicas'>
                <div class='section-text'>
                    <h1 class='my-0 mb-2'>Black Friday Chico Rei 2024: Camisetas em promoção</h1>
                    <span>
                        A <strong>maior promoção de camisetas é na Black Friday Chico Rei 2024!</strong> Você ainda ganha <strong>20% de cashback</strong> em todo o Site! Aproveite entre os dias <strong>11 e 30 de novembro de 2024.</strong>
                    </span>
                    <h2>Camisetas em Black Friday</h2>
                    <span>
                        As <strong>camisetas estampadas mais criativas do Brasil</strong> estão na
                        Black Friday Chico Rei 2024! Aproveite todas as camisetas por
                        <strong>R$37,90 + 20% de Cashback!</strong>
                    </span>
                </div>
                <div class='section-products'>
                    <template>
                        <div class='product-grid secondary'>
                            <div v-for='(item, index) in mainProducts' class='product-item'>
                                <a :href='item.url' target='_blank'>
                                    <picture>
                                        <source :srcset='item.image' media='(min-width: 768px)' />
                                        <img
                                            :src='item.image_mobile'
                                            class='item-img img-responsive'
                                            :alt='item.text'
                                        />
                                    </picture>
                                    <div class='item-hover hidden-sm hidden-xs'>
                                        <span class='text-uppercase'>{{ item.text }}</span>
                                    </div>
                                </a>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
            <div class='section-basicas'>
                <div class='section-text'>
                    <h2 class='my-0 mb-2'>Descontos exclusivos na Newsletter da Chico Rei</h2>
                    <span>
                        <strong>Inscreva-se na Newsletter da Chico Rei</strong> para ganhar
                        <strong>descontos exclusivos</strong> e ficar por dentro de
                        <strong>todas as novidades antes de todo mundo!</strong>
                    </span>
                </div>
                <a class='text-no-decoration cursor-pointer' href='/newsletter' target='_blank'>
                    <picture>
                        <source
                            :srcset='`${$scope.CDN_IMAGES}/images/hotsites/blackfriday-2024/bnr_pagina_bf_mob_newsletter_051124.png?auto=compress,format&q=65`'
                            media='(max-width: 576px)'
                        />
                        <img
                            :src='`${$scope.CDN_IMAGES}/images/hotsites/blackfriday-2024/bnr_pagina_bf_desk_newsletter_051124.png?auto=compress,format&q=65`'
                            class='img-responsive'
                            alt='Inscreva-se na Newsletter da Chico Rei'
                        />
                    </picture>
                </a>
            </div>
            <div class='section-basicas'>
                <div class='section-text'>
                    <h2 class='my-0 mb-2'>Grandes sucessos da Black Friday Chico Rei</h2>
                    <span>
                        Ainda não sabe como aproveitar a Black Friday da Chico Rei? Fica tranquilo
                        que a gente te ajuda!
                        <strong
                        >Selecionamos os produtos mais vendidos por aqui para você conferir e,
                            claro, garantir os seus.</strong
                        >
                        Clique no banner abaixo para saber mais.
                    </span>
                </div>
                <div class='section-products'>
                    <a class='text-no-decoration cursor-pointer' :href='bannerTopSelling.url' target='_blank'>
                        <picture>
                            <source
                                :srcset='bannerTopSelling.image.desktop'
                                media='(min-width: 576px)'
                            />
                            <img
                                :src='bannerTopSelling.image.mobile'
                                alt='Grandes Sucessos Chico Rei'
                                class='img-responsive center-block'
                            />
                        </picture>
                    </a>
                </div>
            </div>
            <div class='section-basicas'>
                <div class='section-text'>
                    <h2 class='my-0 mb-2'>Mais roupas em Black Friday</h2>
                    <span>
                        Confira nossos <a href='/moletom' target='_blank'>casacos de moletom</a>,
                        <a href='/meia' target='_blank'>meias</a>,
                        <a href='/camisa-de-botao' target='_blank'>camisetas de botão</a>,
                        <a href='/regata' target='_blank'>regatas</a>,
                        <a href='/cropped' target='_blank'>croppeds</a>,
                        <a href='/calcas' target='_blank'>calças</a>,
                        <a href='/bermudas' target='_blank'>bermudas</a> e
                        <a href='/short' target='_blank'>shorts</a> em promoção na Black Friday.
                    </span>
                </div>
                <div class='d-flex flex-justify-center'>
                    <a class='text-no-decoration cursor-pointer' href='/promo' target='_blank'>
                        <picture>
                            <source
                                :srcset='`${$scope.CDN_IMAGES}/images/hotsites/blackfriday-2024/bnr_pagina_bf_mob_roupas_051124.png?auto=compress,format&q=65`'
                                media='(max-width: 576px)'
                            />
                            <img
                                :src='`${$scope.CDN_IMAGES}/images/hotsites/blackfriday-2024/bnr_pagina_bf_desk_roupas_051124.png?auto=compress,format&q=65`'
                                class='img-responsive'
                                alt='Mais Roupas Black Friday Chico Rei'
                            />
                        </picture>
                    </a>
                </div>
            </div>
            <div class='section-basicas'>
                <div class='section-text'>
                    <h2 class='my-0 mb-2'>Acessórios em Black Friday</h2>
                    <span>
                        Aproveite os descontos imperdíveis em nossas
                        <a href='/black-friday/bolsa' target='_blank'>bolsas</a>,
                        <a href='/mochila' target='_blank'>mochilas</a> e
                        <a href='/carteira' target='_blank'>carteiras</a> em Black Friday.
                    </span>
                </div>
                <div class='d-flex flex-column flex-align-start'>
                    <h3 class='ml-3 hidden-xs-up'>Bolsas</h3>
                    <h3 class='hidden-xs-down'>Bolsas</h3>
                    <a class='text-no-decoration cursor-pointer' href='/black-friday/bolsa' target='_blank'>
                        <picture>
                            <source
                                :srcset='`${$scope.CDN_IMAGES}/images/hotsites/blackfriday-2024/bnr_pagina_bf_mob_bolsas_051124.png?auto=compress,format&q=65`'
                                media='(max-width: 576px)'
                            />
                            <img
                                :src='`${$scope.CDN_IMAGES}/images/hotsites/blackfriday-2024/bnr_pagina_bf_desk_bolsas_051124.png?auto=compress,format&q=65`'
                                class='img-responsive'
                                alt='Bolsas Black Friday Chico Rei'
                            />
                        </picture>
                    </a>
                    <h3 class='ml-3 hidden-xs-up'>Mochilas</h3>
                    <h3 class='hidden-xs-down'>Mochilas</h3>
                    <a class='text-no-decoration cursor-pointer' href='/mochila' target='_blank'>
                        <picture>
                            <source
                                :srcset='`${$scope.CDN_IMAGES}/images/hotsites/blackfriday-2024/bnr_pagina_bf_mob_mochilas_051124.png?auto=compress,format&q=65`'
                                media='(max-width: 576px)'
                            />
                            <img
                                :src='`${$scope.CDN_IMAGES}/images/hotsites/blackfriday-2024/bnr_pagina_bf_desk_mochilas_051124.png?auto=compress,format&q=65`'
                                class='img-responsive'
                                alt='Bolsas Black Friday Chico Rei'
                            />
                        </picture>
                    </a>
                </div>
            </div>
            <div class='section-basicas'>
                <div class='section-text'>
                    <h2 class='my-0 mb-2'>Casa e decoração em Black Friday</h2>
                    <span>
                        <a href='/bandeira' target='_blank'>Bandeiras decorativas</a>,<a
                        href='/caneca'
                        target='_blank'
                    >
                            canecas personalizadas</a
                    >
                        e <a href='/poster' target='_blank'>posters</a> com os maiores descontos do
                        ano!
                    </span>
                </div>
                <div class='section-products'>
                        <div class='product-grid secondary more-gap'>
                            <div v-for='item in mainProductsOthers'>
                                <h3 class='text-center'>{{ item.type }}</h3>
                                <div class='product-item'>
                                    <a :href='item.url' target='_blank'>
                                        <picture>
                                            <source
                                                :srcset='item.image'
                                                media='(min-width: 768px)'
                                            />
                                            <img
                                                :src='item.image_mobile'
                                                class='item-img img-responsive'
                                            />
                                        </picture>
                                        <div class='item-hover hidden-sm hidden-xs'>
                                            <span class='text-uppercase'>{{ item.text }}</span>
                                        </div>
                                    </a>
                                </div>
                            </div>
                        </div>
                </div>
            </div>
            <div class='section-basicas'>
                <div class='section-text'>
                    <h2 class='my-0 mb-2'>Collabs em Black Friday</h2>
                    <span>
                        Descontos exclusivos em produtos das nossas
                        <strong
                        >parcerias com grandes artistas e personalidades da cultura
                            brasileira.</strong
                        >
                    </span>
                </div>
                <div class='d-flex flex-justify-center'>
                    <a class='text-no-decoration cursor-pointer' href='/colecoes' target='_blank'>
                        <picture>
                            <source
                                :srcset='`${$scope.CDN_IMAGES}/images/hotsites/blackfriday-2024/bnr_pagina_bf_mob_colabs_051124.png?auto=compress,format&q=65`'
                                media='(max-width: 576px)'
                            />
                            <img
                                :src='`${$scope.CDN_IMAGES}/images/hotsites/blackfriday-2024/bnr_pagina_bf_desk_colabs_051124.png?auto=compress,format&q=65`'
                                class='img-responsive'
                                alt='Bolsas Black Friday Chico Rei'
                            />
                        </picture>
                    </a>
                </div>
            </div>
            <div class='section-basicas'>
                <div class='section-text'>
                    <h2 class='my-0 mb-2'>Black Friday nas Lojas Físicas da Chico Rei</h2>
                </div>
                <div class='d-flex flex-justify-center'>
                    <a class='text-no-decoration cursor-pointer' href='/nossas-lojas' target='_blank'>
                        <picture>
                            <source
                                :srcset='`${$scope.CDN_IMAGES}/images/hotsites/blackfriday-2024/bnr_pagina_bf_mob_lojas_051124.png?auto=compress,format&q=65`'
                                media='(max-width: 576px)'
                            />
                            <img
                                :src='`${$scope.CDN_IMAGES}/images/hotsites/blackfriday-2024/bnr_pagina_bf_desk_lojas_051124.png?auto=compress,format&q=65`'
                                class='img-responsive'
                                alt='Bolsas Black Friday Chico Rei'
                            />
                        </picture>
                    </a>
                </div>
                <div class='section-text'>
                    <p>
                        Venha conhecer as nossas <strong>lojas físicas e aproveite as promoções da Black
                        Friday Chico Rei 2024.</strong>
                        Entre os dias <strong>25 e 30 de novembro</strong>, as lojas da Chico Rei em <strong>Juiz de
                        Fora,
                        Belo Horizonte</strong> e <strong>Tiradentes</strong> estarão com descontos exclusivos da Black
                        Friday.
                    </p>
                    <p>
                        <strong>Ganhe desconto progressivo em camisetas e aproveite para renovar seu
                            guarda-roupa:</strong>
                        <ul>
                            <li><strong>2 peças:</strong> 10% OFF*</li>
                            <li><strong>3 peças:</strong> 15% OFF*</li>
                            <li><strong>4 ou mais peças:</strong> 20% OFF*</li>
                        </ul>
                    </p>
                    <p style='font-size: 0.8rem'>
                        *A promoção não tem validade para peças em Outlet.
                    </p>
                </div>
            </div>
            <div class='section-basicas'>
                <div class='section-text'>
                    <h3 class='my-0 mb-2 h1'>Loja Chico Rei Juiz de Fora</h3>
                    <img
                        :src='`${$scope.CDN_IMAGES}/images/hotsites/blackfriday-2024/loja-chico-rei-juiz-de-fora-rua-padre-cafe.png?auto=compress,format&q=65&w=1250&h=300&fit=crop`'
                        class='img-responsive'
                        alt='Loja Chico Rei Juiz de Fora'
                    />
                    <span>
                        <strong>Endereço:</strong> R. Padre Café, 128, São Mateus, Juiz de Fora / MG.<br>
                        <strong>Horário de funcionamento:</strong> Seg a Sexta: 10h às 19h. Sábado de 10h às 14h<br>
                        <a href='https://g.co/kgs/trVtKt7' target='_blank'>Clique aqui para acessar o mapa.</a>
                    </span>
                </div>
                <div class='section-text'>
                    <h3 class='my-0 mb-2 h1'>Loja Chico Rei Belo Horizonte</h3>
                    <img
                        :src='`${$scope.CDN_IMAGES}/images/hotsites/blackfriday-2024/loja-chico-rei-belo-horizonte.png?auto=compress,format&q=65&w=1250&h=300&fit=crop`'
                        class='img-responsive'
                        alt='Loja Chico Rei Juiz de Fora'
                    />
                    <span>
                        <strong>Endereço:</strong> Rua Rio Grande do Sul, 499 - 3º andar, Mercado Novo, Centro Belo Horizonte / MG.<br>
                        <strong>Horário de funcionamento:</strong> Terça: 10h às 19h, Quarta a Sábado: 10h às 21h, Domingo: 10h às 16h.<br>
                        <a href='https://g.co/kgs/uTWU1jo' target='_blank'>Clique aqui para acessar o mapa.</a>
                    </span>
                </div>
                <div class='section-text'>
                    <h3 class='my-0 mb-2 h1'> Loja Chico Rei Tiradentes </h3>
                    <img
                        :src='`${$scope.CDN_IMAGES}/images/hotsites/blackfriday-2024/loja-chico-rei-tiradentes-2.png?auto=compress,format&q=65&w=1250&h=300&fit=crop`'
                        class='img-responsive'
                        alt='Loja Chico Rei Juiz de Fora'
                    />
                    <span>
                        <strong>Endereço:</strong> Rua Direita, 232, Centro Tiradentes / MG.<br>
                        <strong>Horário de funcionamento:</strong> Dom a Ter: 10h às 18h, Qua a Sex: 10h às 19h, Sábado: 10h às 21h.<br>
                        <a href='https://g.co/kgs/rxbmqpB' target='_blank'>Clique aqui para acessar o mapa.</a>
                    </span>
                </div>
            </div>
            <div class='section-basicas'>
                <div class='section-text'>
                    <h2 class='my-0 mb-2'>Conteúdo para te ajudar a se preparar para a Black Friday 2024</h2>
                    <span>
                        Preparamos uma série de <strong>conteúdos em nosso <a href='https://blog.chicorei.com/'
                                                                              target='_blank'>blog</a></strong> para te ajudar a aproveitar as promoções da Black Friday 2024. Compre com segurança e não caia em golpes.
                    </span>
                </div>
                <div class='d-flex flex-justify-center'>
                    <a class='text-no-decoration cursor-pointer' href='https://blog.chicorei.com/' target='_blank'>
                        <picture>
                            <source
                                :srcset='`${$scope.CDN_IMAGES}/images/hotsites/blackfriday-2024/bnr_pagina_bf_mob_conteudos_051124.png?auto=compress,format&q=65`'
                                media='(max-width: 576px)'
                            />
                            <img
                                :src='`${$scope.CDN_IMAGES}/images/hotsites/blackfriday-2024/bnr_pagina_bf_desk_conteudos_051124.png?auto=compress,format&q=65`'
                                class='img-responsive'
                                alt='Bolsas Black Friday Chico Rei'
                            />
                        </picture>
                    </a>
                </div>
            </div>
            <div class='section-basicas'>
                <div class='section-text'>
                    <h2 class='my-0 mb-2'> Black Friday Chico Rei 2024 <span class='toggle-description cursor-pointer'
                                                                             @click='openBlackFriday = !openBlackFriday'>{{
                            openBlackFriday ? '(ver menos)' : '(ver mais)'
                        }}</span>
                    </h2>
                    <div v-if='openBlackFriday' class='mt-3'>
                        <span>A <strong>promoção da Black Friday 2024 da Chico Rei</strong> está repleta dos nossos maiores sucessos para você comprar com <strong>muito desconto e cashback!</strong><br>
                        Aproveite de <strong>11 a 30 de novembro</strong> todas as camisetas por <strong>R$37,90 + 20% de Cashback em todo site!</strong> Encha o carrinho e garanta aquela <strong>camiseta que você sempre sonhou em vestir!</strong></span>
                        <h3 class='my-0 mb-2 mt-3'>
                            Camiseta masculina em Black Friday
                        </h3>
                        <span>
                            Nossas <a href='/camiseta/masculino/' target='_blank'>camisetas masculinas</a> estão em promoção na Black Friday! Aproveite para renovar o seu guarda-roupa com as <strong>camisetas masculinas estampadas</strong> mais criativas e divertidas do mundo! São promoções e descontos exclusivos em camisetas masculinas durante toda a Black Friday Chico Rei.
                        </span>
                        <h3 class='my-0 mb-2 mt-3'>
                            Camiseta Feminina em Black Friday
                        </h3>
                        <span>
                            As <strong><a href='/camiseta/feminino/'>camisetas femininas</a> mais estilosas</strong> da Chico Rei estão com desconto imperdíveis na promoção de Black Friday 2024! Essa é a hora perfeita para garantir aquela estampa que você tem namorado a meses!
                        </span>
                        <h3 class='my-0 mb-2 mt-3'>
                            Camiseta estampada em Black Friday
                        </h3>
                        <span>
                            Na Black Friday Chico Rei você encontra as camisetas estampadas mais criativas e estilosas do Brasil. Nossas camisetas estampadas são desenvolvidas por um <strong>time de artistas</strong> responsáveis por criar as <strong>estampas mais criativas.</strong> São camisetas estampadas com grandes <a
                            href='/camiseta/de-filmes/' target='_blank'>clássicos do cinema</a>, <a
                            href='/camiseta/series/' target='_blank'>séries</a>, <a href='/camiseta/arte/'
                                                                                    target='_blank'>arte</a>, <a
                            href='/camiseta/musica/' target='_blank'>música</a>, <a href='/camiseta/games/'
                                                                                    target='_blank'>jogos</a>, <a
                            href='/camiseta/geek/' target='_blank'>cultura geek</a>, <a href='/camiseta/anime/'
                                                                                        target='_blank'>animes</a>, <a
                            href='/camiseta/animais/' target='_blank'>animais</a> e <a href='/camiseta' target='_blank'>muito mais.</a><br>
                            <strong>Compre sua camiseta estampada com descontos incríveis na Black Friday Chico Rei 2024.</strong>
                        </span>
                        <h3 class='my-0 mb-2 mt-3'>
                            Camiseta Infantil em Black Friday
                        </h3>
                        <span>
                            As ,<strong><a href='/roupas/infantil/' target='_blank'>camisetas infantis</a> mais divertidas e aconchegantes</strong>  da Chico Rei estão com descontos na promoção de Black Friday 2024! Essa é a hora de garantir a sua camiseta infantil personalizada com os sucessos do entretenimento infantil, como o <a
                            href='/mundo-bita' target='_blank'>Mundo Bita.</a>
                        </span>
                        <h3 class='my-0 mb-2 mt-3'>
                            Camisetas Masculina Básica em Black Friday
                        </h3>
                        <span>As <a href='/camiseta/linha-basica/' target='_blank'>camisetas básicas masculinas</a> também estão em promoção na Black Friday. Essa é a opção perfeita para quem gosta de um visual mais simples, mas sem perder o estilo e o conforto. <br>
                        Escolha a sua entre ,<strong>11 opções de cores</strong>, uma mais linda que a outra!</span>
                        <h3 class='my-0 mb-2 mt-3'>
                            Camisetas Feminina Básica em Black Friday
                        </h3>
                        <span>
                            Na Black Friday Chico Rei 2024, você encontra <strong><a href='/camiseta/linha-basica/'
                                                                                     target='_blank'>camisetas básicas femininas</a></strong> em promoção! São <strong>11 opções de cores para você montar uma infinidade de looks</strong>, para as mais diversas ocasiões.
                        </span>
                        <h3 class='my-0 mb-2 mt-3'>
                            Camisetas veganas em Black Friday
                        </h3>
                        <span>
                            Na Black Friday Chico Rei 2024, você encontra <strong>camisetas veganas, com selo de aprovação da PETA</strong>, em promoção! Nossas camisetas são sustentáveis e não apresentam nenhum tipo de exploração animal durante todo o seu processo de fabricação.
                        </span>
                        <h3 class='my-0 mb-2 mt-3'>
                            Camiseta de algodão Pima em Black Friday
                        </h3>
                        <span>
                            As <a href='/camisetas-pima' target='_blank'>camisetas de algodão Pima</a> são o exemplo perfeito de que é possível sentir-se abraçado por uma peça de roupa! <strong>A coleção de camisetas Pima une conforto, qualidade e afeto em cada peça.</strong> Garanta a sua com os descontos da promoção de Black Friday da Chico Rei.
                        </span>
                        <h3 class='my-0 mb-2 mt-3'>
                            Camiseta de Cânhamo em Black Friday
                        </h3>
                        <span>
                            Confortáveis, versáteis e cheias de boniteza, a coleção de <a href='/camiseta-canhamo'
                                                                                          target='_blank'>camisetas de Cânhamo</a> da Chico Rei é mais uma opção na promoção de Black Friday 2024 da Chico Rei.
                        </span>
                        <h3 class='my-0 mb-2 mt-3'>
                            Camiseta Tech em Black Friday
                        </h3>
                        <span>
                           As <a href='/camiseta-tech'
                                 target='_blank'>Camisetas Tech</a> da Chico Rei são feitas com <strong>91% de malha modal e 9% de elastano</strong>, são <strong>2x mais macias do que o algodão</strong> e contam com um tecido maleável, que se adapta facilmente ao corpo. Elas ainda <strong>regulam a temperatura e tem tecnologia anti odor</strong>. Compre sua Tech Shirt da Chico Rei com até <strong>50% de desconto na Black Friday 2024.</strong>
                        </span>
                        <h3 class='my-0 mb-2 mt-3'>
                            Kit de camisetas em Black Friday
                        </h3>
                        <span>
                           O <a href='/camiseta/kit-de-basicas/' target='_blank'>Kit de Camisetas Básicas</a> da Chico Rei conta com a qualidade que você já conhece em peças-chave para o guarda-roupas de qualquer pessoa. <strong>São 3 camisetas básicas</strong> e você pode escolher entre <strong>3 opções de cores</strong> que vão bem em qualquer ocasião. <strong>Garanta o seu kit de camisetas com desconto na promoção de Black Friday da Chico Rei.</strong>
                        </span>
                        <h3 class='my-0 mb-2 mt-3'>
                            Canecas personalizadas em Black Friday
                        </h3>
                        <span>
                           As <a href='/caneca/' target='_blank'>canecas personalizadas</a> da Chico Rei com as artes mais divertidas estarão em promoção na Black Friday Chico Rei 2024.
                        </span>
                        <h3 class='my-0 mb-2 mt-3'>
                            Moda Masculina em Black Friday
                        </h3>
                        <span>
                           Todos os itens de <strong>Moda Masculina da Chico Rei</strong> estão em promoção na Black Friday 2024. Essa é a oportunidade perfeita para você renovar o seu guarda-roupa de camisetas, camisetas básicas, camisas de botão, regatas, moletons, meias, shorts e muito mais!
                        </span>
                        <h3 class='my-0 mb-2 mt-3'>
                            Moda Feminina em Black Friday
                        </h3>
                        <span>
                           Aproveite a promoção de Black Friday da Chico Rei para conseguir descontos em todos os nossos produtos de <strong>Moda Feminina.</strong> Monte uma infinidade de Looks com as nossas camisetas, camisetas básicas, croppeds, calças, shorts, moletons, meias e muito mais!
                        </span>
                        <h3 class='my-0 mb-2 mt-3'>
                            Moda Infantil em Black Friday
                        </h3>
                        <span>
                            <strong>A criançada não fica de fora da Black Friday da Chico Rei!</strong> Todos os nossos produtos de Moda Infantil estão com descontos na promoção de Black Friday 2024! <strong>Aproveite para conhecer nossas estampas disponíveis em formato adulto e infantil e crie looks combinando com seus filhos!</strong>
                        </span>
                        <h3 class='my-0 mb-2 mt-3'>
                            Acessórios em Black Friday
                        </h3>
                        <span>
                            Garanta os <a href='/acessorios' target='_blank'>acessórios</a> mais lindos da Chico Rei para compor os seus looks. Na promoção de Black Friday da Chico Rei 2024, você encontra a bolsa transversal, a bolsa mensageiro,a  bolsa tote, as mochilas, as pochetes, as carteiras e os bonés com descontos exclusivos!
                        </span>
                        <h3 class='my-0 mb-2 mt-3'>
                            Itens de Casa e Decoração na Black Friday
                        </h3>
                        <span>
                            Aproveite para dar uma repaginada no visual da sua casa com a Black Friday de Itens de <strong><a
                            href='/casa' target='_blank'>Casa e Decoração</a> da Chico Rei</strong>. São <strong>bandeiras decorativas, canecas personalizadas e posters decorativos</strong> com descontos exclusivos na promoção de Black Friday 2024 da Chico Rei.
                        </span>
                        <h3 class='my-0 mb-2 mt-3'>
                            Camisetas personalizadas na Black Friday
                        </h3>
                        <span>
                            As <a href='/camiseta' target='_blank'>camisetas personalizadas</a> da <strong>Chico Rei</strong> estão em promoção na Black Friday 2024! Nossas <strong>camisetas personalizadas</strong> receberam uma missão pra lá de importante: te ajudar a se vestir de personalidade por onde você for! Além da nossa seleção de <strong>camisetas estampadas</strong> que tagarelam, contam histórias, fazem piada e te ajudam a carregar suas referências preferidas no peito, nós também contamos com uma linha de <strong>camisetas básicas</strong> super estilosas e confortáveis!
                        </span>
                        <h3 class='my-0 mb-2 mt-3'>
                            Camisetas Chico Rei em promoção de Black Friday
                        </h3>
                        <span>
                            A promoção de <strong><a href='/black-friday' target='_blank'>Black Friday 2024 da Chico Rei</a></strong> traz uma seleção incrível das camisetas que mais fazem sucesso com super descontos e cashback! <br>
                            De <strong>11 a 30 de novembro</strong>, você pode adquirir todas as camisetas por apenas <strong>R$37,90 e ainda recebe 20% de cashback em todo o site!</strong> Não perca a chance de encher seu carrinho e garantir a camiseta que você sempre quis!
                        </span>
                    </div>
                </div>
            </div>
            <div class='section-basicas'>
                <div class='section-text'>
                    <h2 class='my-0 mb-2'> Regulamento Black Friday Chico Rei 2024 <span class='toggle-description cursor-pointer'
                                                                             @click='openRegulamento = !openRegulamento'>{{
                            openRegulamento ? '(ver menos)' : '(ver mais)'
                        }}</span>
                    </h2>
                    <div v-if='openRegulamento' class='mt-3'>
                        <ul>
                            <li>Promoção não cumulativa com cupons de desconto e outras ofertas, exceto quando indicado nas regras de uso de cada cupom</li>
                            <li>A promoção é válida para os produtos indicados com o selo da promoção</li>
                            <li>A oferta de camisetas não é válida para a Coleção Vasco da Gama, que terá ofertas diferentes</li>
                            <li>A oferta não é válida para Malhas Especiais e afins, como Algodão Pima, Camiseta Tech e Cânhamo</li>
                            <li>Em caso de troca, o valor do cupom gerado terá o mesmo valor pago em cada produto</li>
                            <li>Oferta válida até 29/11/2024 ou enquanto durar o estoque destinado à promoção</li>
                            <li>A Chico Rei se reserva o direito de encerrar ou prorrogar a promoção sem aviso prévio</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="section-basicas mt-1" :style="{ width: `100%` }">
                <div class="section-text">
                    <h2 class="my-0">Perguntas Frequentes Black Friday Chico Rei 2024</h2>
                </div>
                <div class="section-products asked-questions mt-4" :style="{ alignItems: `flex-start` }">
                    <div
                        id="description-basicas"
                        class="my-0"
                        v-for="item in frequentlyAskedQuestions"
                    >
                        <div class="description-title " @click="item.showText = !item.showText">
                            <h3>
                                {{ item.title }}
                                <span class="toggle-description">{{
                                        item.showText ? '(ver menos)' : '(ver mais)'
                                    }}</span>
                            </h3>
                        </div>
                        <div class="description-content my-2" :class="{ visible: item.showText }">
                            <div class="my-2" v-html="item.text"></div>
                        </div>
                    </div>
                    <div class="h-text-divider mt-2" />
                </div>
            </div>
        </div>
<!--            <div class='section-basicas'>-->
<!--                <div id='description-basicas' class='my-0'>-->
<!--                    <div-->
<!--                        class='description-title'-->
<!--                        @click='showPreBlackContent = !showPreBlackContent'-->
<!--                    >-->
<!--                        <span>Fique por dentro de tudo dessa Black Friday</span>-->
<!--                        <span class='toggle-description'>{{-->
<!--                                showPreBlackContent ? '(ocultar)' : '(mostrar)'-->
<!--                            }}</span>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        <div id='pre-black-wrapper' class='px-0' v-if='showPreBlackContent'>-->
<!--            <PreBlackContent />-->
<!--            <PreBlackProductList />-->
<!--        </div>-->
    </div>
</template>

<script>
    import PreBlackContent from '../pre-black-friday/content/PreBlackContent.vue';
    import PreBlackProductList from '../pre-black-friday/content/PreBlackProductList.vue';
    import { scrollToPosition } from '../../../../../submodules/src/script/common';

    export default {
        name: 'BlackFriday2023',
        el: '#black-friday-2023-vue',
        components: {
            PreBlackContent,
            PreBlackProductList,
        },

        data() {
            return {
                showCoupon: false,
                showNewsletter: false,
                showShipping: false,
                showReliable: false,
                showBestPrices: false,
                showPreBlackContent: false,
                openBlackFriday: false,
                openRegulamento: false,

                bannerMain: {
                    image: {
                        desktop:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/black-friday-promo-vigente.png?auto=compress,format&q=65&h=800&w=1920&fit=clamp`,
                        mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/blackfriday-2023/durante-black/banner_topo_promovigente_1_412x740.png?auto=compress,format&q=65&w=412&h=600&fit=crop`,
                    },
                },
                bannerTopSelling: {
                    image: {
                        desktop:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/blackfriday-2024/bnr_pagina_bf_desk_sucessos_051124.png?auto=compress,format&q=65`,
                        mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/blackfriday-2024/bnr_pagina_bf_mob_sucessos_051124.png?auto=compress,format&q=65`,
                    },
                    url: `/black-friday/sucessos`,
                },
                aboutUs: {
                    image:
                        this.$scope.CDN_IMAGES +
                        `/images/hotsites/blackfriday-2023/durante-black/sobre-a-chico.jpeg?auto=compress,format&q=65`,
                },
                mainProducts: [
                    {
                        text: `Ver camisetas de cultura brasileira`,
                        url: `/camiseta/brasilidade/`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-brasilidade-1-d.png?auto=compress,format`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetsa-brasilidade-1.png?auto=compress,format`,
                    },
                    {
                        text: `Ver camisetas de filmes`,
                        url: `/camiseta/cinema/`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-cinema-2-d.png?auto=compress,format`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-cinema-2.png?auto=compress,format`,
                    },
                    {
                        text: `Ver camisetas geek`,
                        url: `/camiseta/geek/`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-geek-3-d.png?auto=compress,format`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-geek-3.png?auto=compress,format`,
                    },

                    {
                        text: `Ver camisetas engraçadas`,
                        url: `/camiseta/humor/`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-humor-4-d.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-humor-4.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                    },
                    {
                        text: `Ver camisetas de literatura`,
                        url: `/camiseta/literatura/`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-literatura-5-d.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-literatura-5.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                    },
                    {
                        text: `Ver camisetas de música`,
                        url: `/camiseta/musica/`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-musica-6-d.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-musica-6.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                    },
                    {
                        text: `Ver camisetas de séries`,
                        url: `/camiseta/series/`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-series-7-d.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-serie-7.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                    },
                    {
                        text: `Ver camisetas com frases`,
                        url: `/camiseta/tipografia/`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-tipografia-8-d.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/bf-23/camisetas-tipografia-8.png?auto=compress,format&q=65&w=550&h=824&fit=crop&crop=top`,
                    },
                ],
                mainProductsOthers: [
                    {
                        type: 'Caneca',
                        text: `Ver mais canecas`,
                        url: `/promo/?tipo=17`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/blackfriday-2024/banners_promo_caneca_256x384_131124.png?auto=compress,format`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/blackfriday-2024/banners_promo_caneca_306x459_131124.png?auto=compress,format`,
                    },
                    {
                        type: 'Poster',
                        text: `Ver mais posters`,
                        url: `/promo/?tipo=6`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/blackfriday-2024/banners_promo_posters_256x384_131124.png?auto=compress,format`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/blackfriday-2024/banners_promo_posters_306x459_131124.png?auto=compress,format`,
                    },
                    {
                        type: 'Bandeira',
                        text: `Ver mais bandeiras`,
                        url: `/promo/?tipo=43`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/blackfriday-2024/banners_promo_bandeira_256x384_131124.png?auto=compress,format`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/blackfriday-2024/banners_promo_bandeira_306x459_131124.png?auto=compress,format`,
                    },

                    {
                        type: 'Meia',
                        text: `Ver mais meias`,
                        url: `/promo/?tipo=33`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/blackfriday-2024/banners_promo_meia_256x384_131124.png?auto=compress,format`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/blackfriday-2024/banners_promo_meia_306x459_131124.png?auto=compress,format`,
                    },
                    {
                        type: 'Bolsa',
                        text: `Ver mais bolsas`,
                        url: `/promo/?tipo=25`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/blackfriday-2024/banners_promo_mochila_256x384_131124.png?auto=compress,format`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/blackfriday-2024/banners_promo_mochila_306x459_131124.png?auto=compress,format`,
                    },
                    {
                        type: 'Avental',
                        text: `Ver mais aventais`,
                        url: `/promo/?tipo=31`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/blackfriday-2024/banners_promo_avental_256x384_131124.png?auto=compress,format`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/blackfriday-2024/banners_promo_avental_306x459_131124.png?auto=compress,format`,
                    },
                    {
                        type: 'Short',
                        text: `Ver mais shorts`,
                        url: `/promo/?tipo=44`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/blackfriday-2024/banners_promo_bermuda_256x384_131124.png?auto=compress,format`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/blackfriday-2024/banners_promo_bermuda_306x459_131124.png?auto=compress,format`,
                    },
                    {
                        type: 'Sketchbook',
                        text: `Ver mais sketchbooks`,
                        url: `/promo/?tipo=18`,
                        image:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/blackfriday-2024/banners_promo_sketchbook_256x384_131124.png?auto=compress,format`,
                        image_mobile:
                            this.$scope.CDN_IMAGES +
                            `/images/hotsites/blackfriday-2024/banners_promo_sketchbook_306x459_131124.png?auto=compress,format`,
                    },
                ],
                frequentlyAskedQuestions: [
                    {
                        title: 'Quando começa a Black Friday 2024 da Chico Rei?',
                        text: `<p>A <strong>Black Friday Chico Rei começa no dia 11 de Novembro</strong>. Você pode aproveitar todas as promoções da Black Friday Chico Rei de <strong>11 a 30 de novembro.</strong></p>`,
                        showText: false,
                    },
                    {
                        title: 'O que posso esperar na Black Friday da Chico Rei?',
                        text: `<p>Na <strong>Black Friday 2024 da Chico Rei</strong> você encontrará <a href='/camiseta' target='_blank'>camisetas estampadas</a>, <a href='/basico' target='_blank'>camisetas básicas</a>, <a href='/caneca' target='_blank'>canecas personalizadas</a>, <a href='/bolsa' target='_blank'>bolsas</a> e muito mais com descontos incríveis!</p>`,
                        showText: false,
                    },
                    {
                        title: 'Como funciona a Black Friday da Chico Rei?',
                        text: `<p>A <strong>Black Friday Chico Rei começa no dia 11 de Novembro</strong>, com promoções durante todo o mês. Fique atento ao <a href='/' target='_blank'>site da Chico Rei</a> para não perder nenhuma das promoções!</p>
                                <p>São camisetas por <strong>R$37,90 + 20% de cashback em todo site!*</strong></p>
                                <p><strong>Saiba antes de todo mundo</strong> as novidades da <strong>Black Friday Chico Rei 2024</strong> e receba promoções exclusivas na newsletter da Chico Rei.</p>
                                <p><a href='/newsletter' target='_blank'>Inscreva-se aqui na Newsletter da Chico Rei</a></p>
                                <p><strong>*Compras com os seguintes produtos não geram cashback: </strong>Vale-presente, Disco de Vinil e Embalagem Extra</p>`,
                        showText: false,
                    },
                    {
                        title: 'A Black Friday da Chico Rei tem frete grátis?',
                        text: `<p><strong>Sim!</strong> Continuamos com a mesma política de valores mínimos por região de envio. Aproveite para <strong>comprar com frete grátis na Black Friday Chico Rei 2024!</strong></p>
                               <p>Você pode verificar a tabela de frete grátis na página do produto. Ao inserir o cep diretamente na sacola de compras, as opções e valores de frete disponíveis vão aparecer para escolha do cliente.</p>`,
                        showText: false,
                    },
                    {
                        title: 'Quais as formas de pagamento da Black Friday da Chico Rei 2024?',
                        text: `<p>Você pode pagar as suas compras realizadas na <strong>Black Friday Chico Rei 2024</strong> por <strong>Pix ou Cartão de Crédito</strong>.</p><p><strong>Parcele no Cartão de crédito</strong> em até <strong>4x sem juros ou até 10x com juros.</strong></p>`,
                        showText: false,
                    },
                    {
                        title: 'Como funciona o cashback na Black Friday Chico Rei?',
                        text: `<p>Durante a Black Friday da Chico Rei 2024, todos <strong>os produtos em que o cashback é válido terão 20% de cashback.</strong></p>
                               <p><strong>Assim, não geram cashback os seguintes produtos:</strong> Vale-presente, Disco de Vinil e Embalagem Extra.</p>
                               <p>Você pode acessar todas as regras de utilização do cashback no <a href='/minha-conta/cashback' target='_blank'>regulamento completo no site.</a></p>`,
                        showText: false,
                    },
                    {
                        title: 'Posso usar um cupom de desconto nas promoções de Black Friday?',
                        text: `<p><strong>Não é possível usar cupons de desconto junto com as promoções da Black Friday</strong>.</p>`,
                        showText: false,
                    },
                    {
                        title: 'Posso alterar meu pedido depois de confirmado?',
                        text: `<p>Se você <strong>selecionou o tamanho ou produto errado</strong> e o seu <strong>pedido ainda não foi produzido/enviado</strong>, entre em contato com nosso time de Atendimento (<a href='mailto:contato@chicorei.com.br' target='_blank'>contato@chicorei.com.br</a> ou <a href='/fale-conosco' target='_blank'>Fale Conosco</a>) que vamos verificar a possibilidade de alteração antes do envio.</p>
                               <p><strong>Lembrando que qualquer alteração implica também no aumento do prazo final de entrega informado na compra, sendo este um processo irreversível.</strong></p>
                               <p><strong>Saiba mais em:</strong> <a href='/central-de-ajuda' target='_blank'>Central de Ajuda - Perguntas Mais Frequentes | Chico Rei</a></p>`,
                        showText: false,
                    },
                    {
                        title: 'Por que o prazo de entrega é tão longo?',
                        text: `<p>Muitos de nossos produtos têm <strong>produção sob demanda</strong>. Com isso, aumentamos muito a variedade de estampas e tamanhos disponíveis em nosso site!</p>
                               <p>Na produção sob demanda, precisamos de um tempo maior para finalizar a produção do seu pedido, mantendo a qualidade Chico Rei de sempre. Ao selecionar o frete, você será informado da data final de entrega do seu pedido e este é o prazo para que receba os produtos Chico Rei na sua casa.</p>
                               <p>Você pode encontrar produtos para <strong>pronta-entrega</strong> na página de <a href='/vapt-vupt' target='_blank'>Vapt-Vupt</a></p>`,
                        showText: false,
                    },
                    {
                        title: 'Escolhi uma camiseta que tem produção sob demanda. O que isto significa?',
                        text: `<p>A produção sob demanda é referente <strong>aos produtos que ainda não temos prontos em nosso estoque</strong>. Isso significa que ele será produzido especialmente para você, após você finalizar a compra. Ao selecionar um produto sob demanda e fechar seu pedido, este produto entrará em produção e será enviado após ficar pronto.</p>`,
                        showText: false,
                    },
                    {
                        title: 'Escolhi a opção Vapt-Vupt. O que isto significa?',
                        text: `<p>Os produtos <strong>Vapt-Vupt</strong> são de <strong>pronta-entrega</strong>, ou seja são os produtos em estoque, <strong>com menor prazo de envio.</strong></p>`,
                        showText: false,
                    },
                    {
                        title: 'Qual a política de devolução da Black Friday Chico Rei 2024?',
                        text: `<p><strong>As devoluções</strong> podem ser feitas <strong>até 7 dias após o recebimento do pedido.</strong> A devolução é sempre gratuita.</p>
                               <p><strong>As trocas</strong>  podem ser solicitadas em <strong>até 30 dias após o recebimento do pedido.</strong></p>
                               <p>Informação bacana de compartilhar: a primeira troca no cadastro do cliente é realizada de forma gratuita</p>
                               <p>Você pode acessar a <strong>política de devolução completa da Chico Rei</strong>no seguinte link <a href='/central-de-ajuda' target='_blank'>Central de Ajuda - Perguntas Mais Frequentes | Chico Rei</a></p>`,
                        showText: false,
                    },
                    {
                        title: 'Recebi o meu pedido e não gostei. Posso fazer uma devolução?',
                        text: `<p><strong>As devoluções</strong> podem ser feitas <strong>até 7 dias após o recebimento do pedido.</strong> A devolução é sempre gratuita.</p>
                               <p><strong>As trocas</strong>  podem ser solicitadas em <strong>até 30 dias após o recebimento do pedido.</strong>Informação bacana de compartilhar: a primeira troca no cadastro do cliente é realizada de forma gratuita</p>
                               <p>As trocas podem ser solicitadas em até 30 dias após o recebimento do pedido. </p>
                               <p>Você pode acessar a <strong>política de devolução completa da Chico Rei</strong>no seguinte link <a href='/central-de-ajuda' target='_blank'>Central de Ajuda - Perguntas Mais Frequentes | Chico Rei</a></p>\``,
                        showText: false,
                    },
                    {
                        title: 'Quando é a Black Friday 2024?',
                        text: `<p>A <strong>Black Friday 2024acontecerá no dia 29 de novembro de 2024</strong> , começando à <strong>meia-noite.</strong> do mesmo dia.</p>
                               <p>A <strong>Black Friday sempre acontece na última sexta-feira do mês de novembro.</strong> Comumente, o <strong>horário de início das promoções de Black Friday é às 00:00h da madrugada</strong> da última sexta-feira do mês de novembro. </p>`,
                        showText: false,
                    },
                    {
                        title: 'Quando é a Black Friday 2024 no Brasil?',
                        text: `<p>A <strong>Black Friday no Brasil acontecerá no dia 29 de novembro de 2024.</strong> O <strong>horário de início da Black Friday</strong>, na maioria das lojas brasileiras, <strong>é às 00:00h</strong> do <strong>horário de Brasília.</strong></p>`,
                        showText: false,
                    },
                    {
                        title: 'Quais produtos entram na Black Friday Chico Rei?',
                        text: `<p><strong>Entram em promoção na Black Friday 2024 da Chico Rei os seguintes produtos:</strong><a href='/camiseta' target='_blank'>camisetas estampadas</a>, <a href='/basico' target='_blank'>camisetas básicas</a>, <a href='/acessorios' target='_blank'>acessórios</a> e <a href='/casa' target='_blank'>itens de casa e decoração</a>.</p>`,
                        showText: false,
                    },
                    {
                        title: 'Quais peças de Moda Masculina estão em promoção na Black Friday Chico Rei 2024?',
                        text: `<p>A <strong>Black Friday 2024 da Chico Rei</strong> terá as seguintes <strong>peças do vestuário masculino em promoção:</strong></p>
                               <ul><li>Camiseta masculina estampada</li><li>Camiseta masculina básica</li><li>Boné masculino</li></ul>`,
                        showText: false,
                    },
                    {
                        title: 'Quais peças de Moda Feminina estão em promoção na Black Friday Chico Rei 2024?',
                        text: `<p>A <strong>Black Friday 2024 da Chico Rei</strong> terá as seguintes <strong>peças do vestuário feminino em promoção:</strong></p>
                               <ul><li>Camiseta feminina estampada</li><li>Camiseta feminina básica</li><li>Boné feminino</li><li>Bolsa Feminina</li></ul>`,
                        showText: false,
                    },
                    {
                        title: 'A Black Friday da Chico Rei tem cashback?',
                        text: `<p>Sim!<strong> A Black Friday 2024 da Chico Rei terá o maior cashback da história!</strong> Saiba mais sobre o cashback da Black Friday 2024 da Chico Rei e <strong>receba descontos exclusivos em nossa newsletter</strong>.</p>
                               <p><a href='/newsletter' target='_blank'>Inscreva-se aqui na Newsletter da Chico Rei</a></p>`,
                        showText: false,
                    },
                    {
                        title: 'Quando começa a Black Friday nas lojas?',
                        text: `<p>A <strong>Black Friday</strong> nas <a href='/nossas-lojas' target='_blank'>lojas físicas da Chico Rei</a> acontece entre os dias <strong>25 a 30 de novembro de 2024</strong>.</p>
                               <p>A Loja da Chico Rei em <strong>Belo Horizonte</strong> estará com promoções de Black Friday  entre os dias <strong>25 a 30 de novembro de 2024</strong>.</p>
                               <p>A Loja da Chico Rei em <strong>Juiz de Fora</strong> estará com promoções de Black Friday  entre os dias <strong>25 a 30 de novembro de 2024</strong>.</p>
                               <p>A Loja da Chico Rei em <strong>Tiradentes</strong> estará com promoções de Black Friday  entre os dias <strong>25 a 30 de novembro de 2024</strong>.</p>`,
                        showText: false,
                    },
                    {
                        title: 'Onde posso tirar dúvidas sobre a Black Friday Chico Rei?',
                        text: `<p>Você pode <strong>sanar todas as suas dúvidas para aproveitar ao máximo os descontos da Black Friday Chico Rei 2024</strong> com o nosso <a href='/fale-conosco' target='_blank'>SAC</a>.</p>
                               <p>Você também pode <strong>tirar todas as suas dúvidas sobre a Black Friday 2024 da Chico Rei</strong> através do nosso <a href='/fale-conosco' target='_blank'>E-mail</a>, <a href='/fale-conosco' target='_blank'>Chat Ao Vivo</a> e página com dúvidas frequentes na nossa <a href='/central-de-ajuda' target='_blank'>Central de Ajuda</a>. </p>`,
                        showText: false,
                    },
                    {
                        title: 'Como receber descontos e ofertas exclusivas na Black Friday da Chico Rei?',
                        text: `<p><strong>Você pode receber descontos e ofertas exclusivas</strong> da <strong>Black Friday Chico Rei 2024</strong> na newsletter da Chico Rei. Inscreva-se antes do início da Black Friday e fique por dentro de todas as novidades e promoções da maior Black Friday da História da Chico Rei. </p>
                               <p>Inscreva-se aqui na <a href='/newsletter' target='_blank'>Newsletter</a> da Chico Rei</p>`,
                        showText: false,
                    },
                    {
                        title: 'Os estoques são limitados durante a Black Friday Chico Rei?',
                        text: `<p><strong>Sim!</strong> A promoção de Black Friday da Chico Rei está repleta de produtos!!</p>
                               <p><strong>Não dê bobeira e aproveite antes que nossos estoques acabem. </strong></p>`,
                        showText: false,
                    },
                    {
                        title: 'Onde encontro os maiores descontos em camisetas na Black Friday?',
                        text: `<p>Os maiores descontos em camisetas na Black Friday 2024 estão na Chico Rei! Compre <strong>camisetas masculinas, camisetas femininas e camisetas infantis</strong> em promoção na Black Friday 2024 por <strong>R$37,90 + 20% de cashback!</strong></p>`,
                        showText: false,
                    },
                    {
                        title: 'Onde encontro os maiores descontos em camiseta masculina na Black Friday?',
                        text: `<p>Os maiores descontos em camisetas masculinas na Black Friday 2024 estão na Chico Rei! Compre <strong>camisetas masculinas</strong> em promoção na Black Friday 2024 por <strong>R$37,90 + 20% de cashback!</strong></p>`,
                        showText: false,
                    },
                    {
                        title: 'Onde encontro os maiores descontos em camiseta feminina na Black Friday?',
                        text: `<p>Os maiores descontos em camisetas femininas na Black Friday 2024 estão na Chico Rei! Compre <strong>camisetas femininas</strong> em promoção na Black Friday 2024 por <strong>R$37,90 + 20% de cashback!</strong></p></p>`,
                        showText: false,
                    },
                    {
                        title: 'Onde encontro os maiores descontos em camiseta básica na Black Friday?',
                        text: `<p>Os maiores descontos em camisetas básicas na Black Friday 2024 estão na Chico Rei! Compre <strong>camisetas básicas</strong> em promoção na Black Friday 2024 por <strong>R$37,90 + 20% de cashback!</strong></p>`,
                        showText: false,
                    },
                    {
                        title: 'Onde encontro os maiores descontos em camiseta básica masculina na Black Friday?',
                        text: `<p>Os maiores descontos em camisetas básicas masculinas na Black Friday 2024 estão na Chico Rei! Compre <strong>camisetas básicas masculinas</strong> em promoção na Black Friday 2024 por <strong>R$37,90 + 20% de cashback!</strong></p>`,
                        showText: false,
                    },
                    {
                        title: 'Onde encontro os maiores descontos em camiseta básica feminina na Black Friday?',
                        text: `<p>Os maiores descontos em camisetas básicas femininas na Black Friday 2024 estão na Chico Rei! Compre <strong>camisetas básicas femininas</strong> em promoção na Black Friday 2024 por <strong>R$37,90 + 20% de cashback!</strong></p>
                               <p><strong>São camisetas estampadas m promoção na Black Friday dos mais diversos temas como: </strong></p><ul><li><a href='/camiseta/animais'>Animais</a></li><li><a href='/camiseta/anime'>Anime</a></li><li><a href='/camiseta/arte'>Arte</a></li><li><a href='/camiseta/brasilidade'>Brasilidade</a></li><li><a href='/camiseta/cafe'>Café</a></li><li><a href='/camiseta/cartoon'>Cartoon</a></li><li><a href='/camiseta/caveira'>Caveira</a></li><li><a href='/camiseta/chico-rei-lab'>Chico Rei Lab</a></li><li><a href='/camiseta/cinema'>Cinema</a></li><li><a href='/camiseta/comida'>Comida</a></li><li><a href='/camiseta/fotografia'>Fotografia</a></li><li><a href='/camiseta/games'>Games</a></li><li><a href='/camiseta/geek'>Geek</a></li><li><a href='/camiseta/humor'>Humor</a></li><li><a href='/camiseta/insta-artistas'>Instagram de artistas</a></li><li><a href='/camiseta/lab-malhas-especiais'>Malhas especiais</a></li><li><a href='/camiseta/latinidade'>Latinidade</a></li><li><a href='/camiseta/literatura'>Literatura</a></li><li><a href='/camiseta/minas-gerais'>Minas Gerais</a></li><li><a href='/camiseta/musica'>Música</a></li><li><a href='/camiseta/musicas-brasileira'>Músicas Brasileira</a></li><li><a href='/camiseta/positividade'>Positividade</a></li><li><a href='/camiseta/rock'>Rock</a></li><li><a href='/camiseta/signos'>Signos</a></li><li><a href='/camiseta/series'>Séries</a></li><li><a href='/camiseta/terror'>Terror</a></li></ul>`,
                        showText: false,
                    },
                    {
                        title: 'Onde encontrar os melhores descontos em camisetas na Black Friday 2024?',
                        text: `<p>Você encontra os melhores descontos em camisetas na Black Friday 2024 no site da Chico Rei. <strong>Todas as camisetas por R$37,90 + 20% de cashback! </strong></p>`,
                        showText: false,
                    },
                    {
                        title: 'Onde encontrar as melhores ofertas de Black Friday em Moda Masculina?',
                        text: `<p>Você encontra os melhores descontos em Moda Masculina na Black Friday 2024 no site da Chico Rei. <strong>Todas as camisetas por R$37,90 + 20% de cashback! </strong></p>`,
                        showText: false,
                    },
                    {
                        title: 'Onde encontrar as melhores ofertas de Black Friday em Moda Feminina?',
                        text: `<p>Você encontra os melhores descontos em Moda Feminina na Black Friday 2024 no site da Chico Rei. <strong>Todas as camisetas por R$37,90 + 20% de cashback! </strong></p>`,
                        showText: false,
                    },
                    {
                        title: 'Como receber descontos e ofertas exclusivas na Black Friday Chico Rei 2024?',
                        text: `<p>Inscreva-se na Newsletter da Chico Rei para ganhar descontos exclusivos e ficar por dentro de todas as novidades antes de todo mundo!</p>
                               <p>Inscreva-se aqui na <a href='/newsletter' target='_blank'>Newsletter</a> da Chico Rei</p>`,
                        showText: false,
                    },
                    {
                        title: 'Onde encontro os maiores descontos em canecas personalizadas na Black Friday?',
                        text: `<p>Os maiores descontos em canecas personalizadas na Black Friday 2024 estão na Chico Rei!</p>
                               <p>São vários modelos de canecas personalizados com personagens da cultura pop, memes, artistas de MPB e muito mais em promoção na Black Friday 2024 por <strong>R$37,90 + 20% de cashback!</strong></p>`,
                        showText: false,
                    },
                    {
                        title: 'O que é um esquenta Black Friday?',
                        text: `<p>O Esquenta Black Friday são um conjunto de promoções que antecedem a Black Friday. <strong>Basicamente, são promoções antecipadas antes da grande promoção.</strong></p>`,
                        showText: false,
                    },
                    {
                        title: 'Qual o melhor dia para comprar na Black Friday?',
                        text: `<p>29 de novembro é o melhor dia para comprar na Black Friday 2024. Na Black Friday Chico Rei 2024 você encontrará as melhores promoções durante todo o mês de novembro. </p>`,
                        showText: false,
                    },
                    {
                        title: 'Quando é o dia do consumidor em 2024?',
                        text: `<p>O dia do consumidor no Brasil aconteceu no dia 15 de março. </p>`,
                        showText: false,
                    },
                    {
                        title: 'O que significa Black Friday?',
                        text: `<p>A Black Friday é uma data do comércio global onde os lojistas oferecem os maiores descontos e as melhores ofertas do ano para os seus consumidores. A Black Friday acontece anualmente após o feriado de ação de graças, ou seja, sempre na última sexta-feira do mês de novembro.</p>
                               <p>A Black Friday se popularizou no Brasil a partir do ano de 2010 e atualmente é um fenômenos que movimenta milhões no mercado nacional. </p>`,
                        showText: false,
                    },
                ],
            };
        },
    };
</script>
